import { render, staticRenderFns } from "./programsDetail.vue?vue&type=template&id=504e3d4a&scoped=true&"
import script from "./programsDetail.vue?vue&type=script&lang=js&"
export * from "./programsDetail.vue?vue&type=script&lang=js&"
import style0 from "./programsDetail.vue?vue&type=style&index=0&id=504e3d4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e3d4a",
  null
  
)

export default component.exports